/**
 * Which theme is showing, and who decided.
 *
 * Dark is a theme choice, not a separate toggle: every theme in the engine
 * declares its own base, so "Fluent Dark" and "Fluent Light" are two entries
 * in one list rather than a switch beside a palette.
 *
 * The system preference decides until someone chooses, and the choice is
 * remembered under the key the design package names.
 */

import { resolveTheme, THEMES } from './themes/themeEngine'
import type { Theme } from '@fluentui/react-components'

const KEY = 'walle.console.eas.theme'

export const FLUENT_DARK = 'fluent-dark'
export const FLUENT_LIGHT = 'fluent-light'

export function availableThemes() {
  return THEMES
}

/** The remembered choice, or the one the operating system asks for. */
export function readThemeId(): string {
  const stored = localStorage.getItem(KEY)
  if (stored && THEMES.some((t) => t.id === stored)) return stored
  const prefersLight =
    typeof window !== 'undefined' &&
    window.matchMedia?.('(prefers-color-scheme: light)').matches
  return prefersLight ? FLUENT_LIGHT : FLUENT_DARK
}

export function rememberThemeId(id: string): void {
  localStorage.setItem(KEY, id)
}

export function themeFor(id: string): Theme {
  return resolveTheme(id)
}
